/**
 * @module api/sbc
 *
 * API для работы с нашим бекендом
 *
 * @version 1.0.6
 * @copyright Kind Challenge 2019
 */

import axios from 'axios';

const KIND_API_URL = 'https://lvfcn94v2d.execute-api.eu-west-1.amazonaws.com/dev/';
// const KIND_API_URL = 'https://mgptxyuyk6.execute-api.eu-west-1.amazonaws.com/dev/';

const SET_HEADERS = token => ({
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  Authorization: `Bearer ${token}`,
});

/**
 * Получение списка списк точек
 *
 * @since Version 1.0.0
 */
export const apiGetPoints = async (token) => {
  const config = {
    headers: SET_HEADERS(token),
  };

  const { data } = await axios.get(`${KIND_API_URL}admin/points`, config);
  return data;
};


/**
 * Получение конфига
 *
 * @since Version 1.0.0
 */
export const apiGetSettings = async (token) => {
  const config = {
    headers: SET_HEADERS(token),
  };

  const { data } = await axios.get(`${KIND_API_URL}admin/settings`, config);

  return data.data;
};


/**
 * Заданиве акции
 *
 * @since Version 1.0.3
 */
export const apiSetPoint = async (token, point) => {
  const data = JSON.stringify({
    point,
  });

  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.post(`${KIND_API_URL}admin/point`, data, config);
  return res;
};


/**
 * Удаление акции
 *
 * @since Version 1.0.6
 */
export const apiDeletePoint = async (token, id) => {
  const config = {
    headers: SET_HEADERS(token),
    data: {
      id,
    },
  };

  const res = await axios.delete(`${KIND_API_URL}admin/point`, config);

  return res;
};


/**
 * Задание категорий фондов
 *
 * @param {array} foundationsCategories - массив со всеми категориями фондов
 *
 * @since Version 1.0.9
 */
export const apiSetFoundationsCategories = async (token, foundationsCategories) => {
  const data = JSON.stringify({
    setting: 'foundationsCategories',
    value: foundationsCategories,
    isPublic: true,
  });

  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.post(`${KIND_API_URL}admin/setting`, data, config);
  return res;
};


/**
 * Получение общей статистики
 *
 * @since Version 1.0.0
 */
export const apiGetStats = async (token) => {
  const config = {
    headers: SET_HEADERS(token),
  };

  const { data } = await axios.get(`${KIND_API_URL}admin/stats`, config);

  return data.data;
};


/**
 * Получение списка e-mail
 *
 * @since Version 1.0.0
 */
export const apiGetEmails = async (token, { limit = undefined, offset = undefined }) => {
  const config = {
    headers: SET_HEADERS(token),
    params: {},
  };

  if (limit !== undefined) {
    config.params.limit = limit;
  }

  if (offset !== undefined) {
    config.params.offset = offset;
  }

  const { data } = await axios.get(`${KIND_API_URL}admin/emails`, config);

  return data;
};


/**
 * Удаление емейла
 *
 * @since Version 1.0.6
 */
export const apiDeleteEmails = async (token, emails) => {
  const config = {
    headers: SET_HEADERS(token),
    data: {
      emails,
    },
  };

  const res = await axios.delete(`${KIND_API_URL}admin/emails`, config);

  return res;
};


/**
 * Получение списка пользователей
 *
 * @since Version 1.0.0
 */
export const apiGetUsers = async (token, { limit = undefined, offset = undefined }) => {
  const config = {
    headers: SET_HEADERS(token),
    params: {},
  };

  if (limit !== undefined) {
    config.params.limit = limit;
  }

  if (offset !== undefined) {
    config.params.offset = offset;
  }

  const { data } = await axios.get(`${KIND_API_URL}admin/users`, config);

  return data;
};


/**
 * Получение списка фондов
 *
 * @since Version 1.0.0
 */
export const apiGetFoundations = async (token, { limit = undefined, offset = undefined }) => {
  const config = {
    headers: SET_HEADERS(token),
    params: {},
  };

  if (limit !== undefined) {
    config.params.limit = limit;
  }

  if (offset !== undefined) {
    config.params.offset = offset;
  }

  const { data } = await axios.get(`${KIND_API_URL}admin/foundations`, config);

  return data;
};


/**
 * Удаление фондов
 *
 * @since Version 1.0.10
 */
export const apiDeleteFoundations = async (token, foundations) => {
  const config = {
    headers: SET_HEADERS(token),
    data: {
      foundations,
    },
  };

  const res = await axios.delete(`${KIND_API_URL}admin/foundations`, config);

  return res;
};


/**
 * Заданиве информации о фонде
 *
 * @since Version 1.0.3
 */
export const apiSetFoundation = async (token, foundation) => {
  const data = JSON.stringify({
    foundation,
  });

  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.post(`${KIND_API_URL}admin/foundation`, data, config);
  return res;
};


/**
 * Получение страницы со стартами
 *
 * @since Version 1.0.0
 */
export const apiGetMarathons = async (token, { limit = undefined, offset = undefined }) => {
  const config = {
    headers: SET_HEADERS(token),
    params: {},
  };

  if (limit !== undefined) {
    config.params.limit = limit;
  }

  if (offset !== undefined) {
    config.params.offset = offset;
  }

  const { data } = await axios.get(`${KIND_API_URL}admin/marathons`, config);

  return data;
};

/**
 * Получение страницы со стартамом и его участниками
 *
 * @since Version 1.0.0
 */
 export const apiGetMarathon = async (token, id) => {
  const config = {
    headers: SET_HEADERS(token),
    params: {},
  };

  const { data } = await axios.get(`${KIND_API_URL}admin/marathons/${id}`, config);

  return data;
};


/**
 * Удаление стартов
 *
 * @since Version 1.0.6
 */
export const apiDeleteMarathons = async (token, marathons) => {
  const config = {
    headers: SET_HEADERS(token),
    data: {
      marathons,
    },
  };

  const res = await axios.delete(`${KIND_API_URL}admin/marathons`, config);

  return res;
};


/**
 * Заданиве информации о старте
 *
 * @since Version 1.0.3
 */
export const apiSetMarathon = async (token, marathon) => {
  const data = JSON.stringify({
    marathon,
  });

  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.post(`${KIND_API_URL}admin/marathon`, data, config);
  return res;
};


/**
 * Задание категорий стартов
 *
 * @param {array} startsCategories - массив со всеми категориями фондов
 *
 * @since Version 1.0.9
 */
export const apiSetStartsCategories = async (token, startsCategories) => {
  const data = JSON.stringify({
    setting: 'startsCategories',
    value: startsCategories,
    isPublic: true,
  });

  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.post(`${KIND_API_URL}admin/setting`, data, config);
  return res;
};


/**
 * Задание цены старта
 *
 * @param {number} price - цена челеджа со стартами
 *
 * @since Version 1.0.9
 */
export const apiSetStartsPrice = async (token, price) => {
  const data = JSON.stringify({
    setting: 'startsPrice',
    value: price,
    isPublic: true,
  });

  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.post(`${KIND_API_URL}admin/setting`, data, config);
  return res;
};


/**
 * Задание категорий акций
 *
 * @param {array} startsCategories - массив со всеми категориями акций
 *
 * @since Version 1.0.10
 */
export const apiSetPointsCategories = async (token, pointsCategories) => {
  const data = JSON.stringify({
    setting: 'pointsCategories',
    value: pointsCategories,
    isPublic: true,
  });

  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.post(`${KIND_API_URL}admin/setting`, data, config);
  return res;
};


/**
 * Задание информации об организаторе старта
 *
 * @since Version 1.0.5
 */
export const apiSetStartsOrganizer = async (token, startsOrganizer) => {
  const data = JSON.stringify({
    startsOrganizer,
  });

  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.post(`${KIND_API_URL}admin/starts-organizers`, data, config);
  return res;
};


/**
 * Получение страницы с организаторами стартов
 *
 * @since Version 1.0.5
 */
export const apiGetStartsOrganizers = async (token, { limit = undefined, offset = undefined }) => {
  const config = {
    headers: SET_HEADERS(token),
    params: {},
  };

  if (limit !== undefined) {
    config.params.limit = limit;
  }

  if (offset !== undefined) {
    config.params.offset = offset;
  }

  const { data } = await axios.get(`${KIND_API_URL}admin/starts-organizers`, config);

  return data;
};


/**
 * Удаление организаторов стартов
 *
 * @since Version 1.0.6
 */
export const apiDeleteStartsOrganizers = async (token, startsOrganizers) => {
  const config = {
    headers: SET_HEADERS(token),
    data: {
      startsOrganizers,
    },
  };

  const res = await axios.delete(`${KIND_API_URL}admin/starts-organizers`, config);

  return res;
};


/**
 * Получение организатора Kindchallendge
 *
 * @since Version 1.0.6
 */
export const apiGetSystemOrganizer = async (token) => {
  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.get(`${KIND_API_URL}admin/organizer/own`, config);

  return res;
};

/**
 * Получение страницы со промокодами
 *
 * @since Version 1.0.6
 */
export const apiGetPromocodes = async (token, { limit = undefined, offset = undefined }) => {
  const config = {
    headers: SET_HEADERS(token),
    params: {},
  };

  if (limit !== undefined) {
    config.params.limit = limit;
  }

  if (offset !== undefined) {
    config.params.offset = offset;
  }

  const { data } = await axios.get(`${KIND_API_URL}admin/promocodes`, config);

  return data;
};


/**
 * Удаление промокодов
 *
 * @since Version 1.0.6
 */
export const apiDeletePromocodes = async (token, promocodes) => {
  const config = {
    headers: SET_HEADERS(token),
    data: {
      promocodes,
    },
  };

  const res = await axios.delete(`${KIND_API_URL}admin/promocodes`, config);

  return res;
};


/**
 * Заданиве информации о промокоде
 *
 * @since Version 1.0.6
 */
export const apiSetPromocode = async (token, promocode) => {
  const data = JSON.stringify({
    promocode,
  });

  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.post(`${KIND_API_URL}admin/promocode`, data, config);
  return res;
};


/**
 * Удаление пользователя
 *
 * @since Version 1.0.6
 */
export const apiDeleteUsers = async (token, id) => {
  const config = {
    headers: SET_HEADERS(token),
    data: {
      id,
    },
  };

  const res = await axios.delete(`${KIND_API_URL}admin/user`, config);

  return res;
};


/**
 * Задание фото
 *
 * @since Version 1.0.3
 */
export const apiSetImage = async (token, image) => {
  const data = JSON.stringify(image);

  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.post(`${KIND_API_URL}admin/update-image`, data, config);
  return res;
};

/**
 * Получение страницы со челленджами
 *
 * @since Version 1.0.0
 */
export const apiGetChallenges = async (token, { limit = undefined, offset = undefined, userId }) => {
  const config = {
    headers: SET_HEADERS(token),
    params: {},
  };

  if (limit !== undefined) {
    config.params.limit = limit;
  }

  if (offset !== undefined) {
    config.params.offset = offset;
  }

  config.params.userId = userId;
  const { data } = await axios.get(`${KIND_API_URL}admin/challenges`, config);

  return data;
};


/**
 * Заданиве информации о челлендже
 *
 * @since Version 1.0.6
 */
export const apiSetChallenge = async (token, challenge) => {
  const data = JSON.stringify(challenge);

  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.patch(`${KIND_API_URL}admin/challenges`, data, config);
  return res;
};

/**
 * Get kindchallenge tax rate
 *
 * @since Version 1.0.6
 */
export const apiGetKindchallengeTaxRate = async (token) => {
  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.get(`${KIND_API_URL}admin/tax`, config);
  return res;
};

/**
 * Set kindchallenge tax rate
 *
 * @since Version 1.0.0
 */
export const apiSetKindchallengeTaxRate = async (token, tax) => {
  const data = JSON.stringify(tax);

  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.put(`${KIND_API_URL}admin/tax`, data, config);
  return res;
};

/**
 * Get news
 *
 * @since Version 1.0.0
 */
export const apiGetNews = async (token, query) => {
  const config = {
    headers: SET_HEADERS(token),
  };

  const queryStr = `limit=${query.limit}&offset=${query.offset}`;

  const res = await axios.get(`${KIND_API_URL}admin/news?${queryStr}`, config);
  return res;
};

/**
 * Set image preview
 *
 * @since Version 1.0.0
 */
export const apiSetImagePreview = async (token, image) => {
  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.post(`${KIND_API_URL}admin/upload/preview`, image, config);
  return res;
};

/**
 * Get news article
 *
 * @since Version 1.0.0
 */
export const apiGetNewsPost = async (token, id) => {
  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.get(`${KIND_API_URL}admin/news/${id}`, config);
  return res;
};

/**
 * Create/update news article
 *
 * @since Version 1.0.0
 */
export const apiPostNews = async (token, article) => {
  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.post(`${KIND_API_URL}admin/news`, article, config);
  return res;
};

/**
 * Delete news article
 *
 * @since Version 1.0.0
 */
export const apiDeleteNewsPost = async (token, articleId) => {
  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.delete(`${KIND_API_URL}admin/news?id=${articleId}`, config);
  return res;
};

/**
 * Get slides
 *
 * @since Version 1.0.0
 */
export const apiGetSlides = async (token) => {
  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.get(`${KIND_API_URL}admin/slides/all`, config);
  return res;
};

/**
 * Create/update slide
 *
 * @since Version 1.0.0
 */
export const apiPostSlide = async (token, slide) => {
  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.post(`${KIND_API_URL}admin/slide`, slide, config);
  return res;
};

/**
 * Update slides order
 *
 * @since Version 1.0.0
 */
export const apiUpdateSlides = async (token, slides) => {
  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.put(`${KIND_API_URL}admin/slides/batch`, slides, config);
  return res;
};


/**
 * Получение списка акций
 *
 * @since Version 1.0.0
 */
export const apiGetPromos = async (token) => {
  const config = {
    headers: SET_HEADERS(token),
  };

  const { data: { data } } = await axios.get(`${KIND_API_URL}admin/promos`, config);
  return data;
};


/**
 * Заданиве акции
 *
 * @since Version 1.0.3
 */
export const apiSetPromo = async (token, promo) => {
  const data = JSON.stringify({
    ...promo,
  });

  const config = {
    headers: SET_HEADERS(token),
  };

  const res = await axios.post(`${KIND_API_URL}admin/promo`, data, config);
  return res;
};


/**
 * Удаление акции
 *
 * @since Version 1.0.6
 */
export const apiDeletePromo = async (token, id) => {
  const config = {
    headers: SET_HEADERS(token),
    params: {
      id,
    },
  };

  const res = await axios.delete(`${KIND_API_URL}admin/promo`, config);

  return res;
};
